import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, Alert } from '@mui/material';
import apiService from '../../services/api';

/**
 * "Forgot your password?" (security hardening batch 3, 30 Sep 2026). The server answers
 * the same way whether or not the email has an account, so this always shows the same
 * confirmation.
 */
export default function ForgotPasswordDialog({ open, onClose, initialEmail = '' }) {
  const [email, setEmail] = useState(initialEmail);
  const [sent, setSent] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const close = () => {
    setSent(null);
    setError('');
    onClose();
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    setError('');
    try {
      const res = await apiService.forgotPassword(email.trim());
      setSent(res.msg || 'If an account exists for that email, we have sent a link to reset the password.');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="xs" aria-labelledby="forgot-password-title">
      <form onSubmit={submit}>
        <DialogTitle id="forgot-password-title">Reset your password</DialogTitle>
        <DialogContent>
          {sent ? (
            <Alert severity="success">{sent}</Alert>
          ) : (
            <>
              <DialogContentText sx={{ mb: 2 }}>
                Enter the email you sign in with and we will send you a link to choose a new password.
              </DialogContentText>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <TextField
                id="forgot-password-email"
                autoFocus fullWidth type="email" label="Email address"
                autoComplete="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>{sent ? 'Close' : 'Cancel'}</Button>
          {!sent && <Button type="submit" variant="contained" disabled={busy || !email.trim()}>{busy ? 'Sending…' : 'Send link'}</Button>}
        </DialogActions>
      </form>
    </Dialog>
  );
}
